import React from 'react';
import { Dialog, DialogTitle, Button, makeStyles } from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center'
  },
  content: {
    width: '100%',
    minWidth: 600,
    maxWidth: 1200,
    maxHeight: '100%',
    overflow: 'visible',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    outline: 0,
    borderRadius: '3px',
    padding: theme.spacing(3)
  },
  buttons: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '2px'
  },
  title: {
    '& .MuiTypography-root': {
      fontSize: '1.1rem'
    }
  }
}));

const ConfirmDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isConfirmDisabled = false,
  children,
  title
}) => {
  const classes = useStyles();

  return (
    <Dialog open={isOpen} onClose={onClose} className={classes.root}>
      <DialogTitle className={classes.title}>{title}</DialogTitle>
      <div className={classes.content}>
        {children}
        <div className={classes.buttons}>
          <Button variant="text" color="primary" onClick={onClose}>
            <FormattedMessage id="prompt.actionCancelLabel" />
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onConfirm}
            disabled={isConfirmDisabled}
          >
            <FormattedMessage id="prompt.actionDoneLabel" />
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
